import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../shared/Image';

const OwnerNameRow = ({
    profile: {
        styleName,
        silkImagePath,
    },
    imagesHost,
}) => (
    <div className="mp-nameRow">
        <Image
            src={`${imagesHost}/png_silks/${silkImagePath}.png`}
            imgHost={imagesHost}
            imgClass="mp-nameRow__silk"
            alt="owner details"
        />
        <h1 className="mp-nameRow__name">
            { styleName }
        </h1>
    </div>
);


OwnerNameRow.propTypes = {
    imagesHost: PropTypes.string.isRequired,
    profile: PropTypes.shape({
        styleName: PropTypes.string.isRequired,
        silkImagePath: PropTypes.string,
    }).isRequired,
};

export default OwnerNameRow;



// WEBPACK FOOTER //
// ./src/js/human/nameRow/OwnerNameRow.jsx